import {selectApprovals} from './approvalsSelectors';
import {selectSupportArealinks} from './supportSelectors';
import {selectDerivates, selectTechnicalData, selectTechnicalDataDerivates, selectUserModelyearsElements,} from './technicalDataSelector';
import {
    selectOptionBasicTableSort,
    selectOptionTableSort,
    selectVirtualizedTableReload,
    selectVirtualizedTableRollback,
    selectVirtualizedTableSelectedIdList,
} from './dynTableSelectors';
import {
    selectActiveIndex,
    selectActiveNews,
    selectAdminArealinks,
    selectDefaultImporter,
    selectFlags,
    selectGroups,
    selectImporter,
    selectImporterList,
    selectModelyearCategories,
    selectNews,
    selectPrivileges,
    selectProMTGroups,
    selectRoles,
    selectSpecConfigs,
    selectSpecs,
    selectUsers,
} from './administrationSelectors';
import {selectBaseOptionsAreaExtraLinks, selectNonSerCategories, selectOptionBasicsPDiPList, selectSerCategories,} from './baseOptionSelectors';
import {selectModeltypebasicPDiPList, selectModeltypeColors,} from './derivatesSelectors';
import {
    selectBaseLinks,
    selectBasicMarketCnr,
    selectClient,
    selectCnrList,
    selectHideEmptyAssignmentsRowsAndColumns,
    selectLanguage,
    selectLanguageList,
    selectLoadingMessages,
    selectLocationTranslations,
    selectModelyears,
    selectOpenApprovalsCount,
    selectPslAreaExtraLinks,
    selectSettingDaemon,
    selectSwitchHeaderMode,
    selectTypefamilyMap,
    selectUserCnrs,
    selectUserDetails,
    selectUserInfo,
    selectUserModelyears,
    selectUserPSLModelyears,
    selectUserRoles,
    selectUserSettings,
    selectUserSubscription,
    selectUserTypefamiliesMap,
    selectVersionInfo,
    selectWorkflows,
} from './generalSelectors';
import {selectKumaExtraLinks} from './kumaSelector';

export {
  selectModeltypeColors,
  selectModeltypebasicPDiPList,
  selectSerCategories,
  selectNonSerCategories,
  selectOptionBasicTableSort,
  selectOptionBasicsPDiPList,
  selectBaseOptionsAreaExtraLinks,
  selectDerivates,
  selectAdminArealinks,
  selectUsers,
  selectGroups,
  selectRoles,
  selectPrivileges,
  selectFlags,
  selectNews,
  selectActiveNews,
  selectModelyearCategories,
  selectImporterList,
  selectImporter,
  selectSpecs,
  selectDefaultImporter,
  selectTechnicalData,
  selectSupportArealinks,
  selectApprovals,
  selectSpecConfigs,
  selectVirtualizedTableRollback,
  selectVirtualizedTableReload,
  selectOptionTableSort,
  selectVirtualizedTableSelectedIdList,
  selectPslAreaExtraLinks,
  selectClient,
  selectSettingDaemon,
  selectUserInfo,
  selectUserDetails,
  selectUserRoles,
  selectUserSettings,
  selectLocationTranslations,
  selectBaseLinks,
  selectLanguageList,
  selectModelyears,
  selectCnrList,
  selectUserCnrs,
  selectUserModelyears,
  selectUserTypefamiliesMap,
  selectUserPSLModelyears,
  selectBasicMarketCnr,
  selectLoadingMessages,
  selectTypefamilyMap,
  selectWorkflows,
  selectOpenApprovalsCount,
  selectVersionInfo,
  selectHideEmptyAssignmentsRowsAndColumns,
  selectUserSubscription,
  selectLanguage,
  selectTechnicalDataDerivates,
  selectUserModelyearsElements,
  selectSwitchHeaderMode,
  selectProMTGroups,
  selectActiveIndex,
  selectKumaExtraLinks
};



// WEBPACK FOOTER //
// ./src/redux/selectors/index.ts